import React, { useEffect, useRef, useState } from 'react';

const StickyFooterAd = () => {
  const bannerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const banner = bannerRef.current;
    if (!banner) return;

    // Clear previous content
    banner.innerHTML = '';

    const iframe = document.createElement('iframe');
    iframe.style.width = '320px';
    iframe.style.height = '50px';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';

    banner.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    // IMPORTANT: Replace this with your actual 320x50 Ad Key
    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <body style="margin:0;padding:0;display:flex;justify-content:center;">
          <script type="text/javascript">
            atOptions = {
              'key': '61e34cb6d751eb1ccab1e416dd9d415b',
              'format': 'iframe',
              'height': 50,
              'width': 320,
              'params': {}
            };
          </script>
          <script type="text/javascript" src="//www.highrevenueformat.com/61e34cb6d751eb1ccab1e416dd9d415b/invoke.js"></script>
        </body>
      </html>
    `);
    doc.close();
  }, []);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      padding: '5px 0',
      minHeight: '60px'
    }}>
      <div style={{ position: 'relative' }}>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            position: 'absolute',
            top: '-15px',
            right: '-15px',
            background: '#333',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '20px',
            height: '20px',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
          }}
        >
          ×
        </button>
        <div ref={bannerRef} />
      </div>
    </div>
  );
};

export default StickyFooterAd;